var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScheduleP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 18L20.4999 19.094C19.9695 19.6741 19.2502 20 18.5002 20C17.7501 20 17.0308 19.6741 16.5004 19.094C15.9693 18.5151 15.25 18.1901 14.5002 18.1901C13.7504 18.1901 13.0312 18.5151 12.5 19.094M3.50003 20H5.17457C5.66376 20 5.90835 20 6.13852 19.9447C6.34259 19.8957 6.53768 19.8149 6.71663 19.7053C6.91846 19.5816 7.09141 19.4086 7.43732 19.0627L20.0001 6.49998C20.8285 5.67156 20.8285 4.32841 20.0001 3.49998C19.1716 2.67156 17.8285 2.67156 17.0001 3.49998L4.43729 16.0627C4.09139 16.4086 3.91843 16.5816 3.79475 16.7834C3.68509 16.9624 3.60428 17.1574 3.55529 17.3615C3.50003 17.5917 3.50003 17.8363 3.50003 18.3255V20Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleP);
export default __webpack_public_path__ + "static/media/ScheduleP.ecff6a074b232f1bd12ee5337144af65.svg";
export { ForwardRef as ReactComponent };